// extracted by mini-css-extract-plugin
module.exports = {"container":"TabsSection_container__1fwi6","main":"TabsSection_main__DzK8B","tab":"TabsSection_tab__33VTL"};